function loadScriptOnce(src, globalCheck) {
	return new Promise((resolve) => {
		if (globalCheck()) {
			resolve();
			return;
		}
		const existing = document.querySelector(`script[src="${src}"]`);
		if (existing) {
			existing.addEventListener("load", () => resolve());
			return;
		}
		const script = document.createElement("script");
		script.src = src;
		script.addEventListener("load", () => resolve());
		document.head.appendChild(script);
	});
}

function fadeOutIntro(intro) {
	intro.classList.add("site-photogallery__video-intro--faded");
	intro.addEventListener("transitionend", () => {
		intro.remove();
	}, { once: true });
}

function removePlaceholder(intro) {
	intro.querySelector(".site-photogallery__video-intro-placeholder")?.remove();
	intro.querySelector(".site-photogallery__video-intro-play")?.remove();
}

// Nothing plays until the visitor clicks the play button. Once clicked it's a
// genuine user gesture, so the video can just play normally with sound straight
// away, and the play button disappears for the rest of playback.

function setupFileIntro(intro) {
	intro.addEventListener("click", () => {
		const video = document.createElement("video");
		video.autoplay = true;
		video.playsInline = true;
		video.setAttribute("disablePictureInPicture", "");
		video.setAttribute("webkit-playsinline", "");

		const src = document.createElement("source");
		src.src = intro.dataset.videoSrc;
		src.type = "video/mp4;codecs=hvc1";
		video.appendChild(src);

		if (intro.dataset.videoWebm) {
			const webmSrc = document.createElement("source");
			webmSrc.src = intro.dataset.videoWebm;
			webmSrc.type = "video/webm";
			video.appendChild(webmSrc);
		}

		intro.prepend(video);
		video.addEventListener("ended", () => fadeOutIntro(intro));
		video.play();
		removePlaceholder(intro);
	}, { once: true });
}

function setupYoutubeIntro(intro) {
	intro.addEventListener("click", () => {
		const iframe = document.createElement("iframe");
		iframe.setAttribute("frameborder", "0");
		iframe.setAttribute("allow", "autoplay; encrypted-media");
		iframe.src = `https://www.youtube-nocookie.com/embed/${intro.dataset.videoSrc}?autoplay=1&rel=0&playsinline=1&enablejsapi=1&controls=0&modestbranding=1&iv_load_policy=3&disablekb=1`;
		intro.prepend(iframe);

		loadScriptOnce("https://www.youtube.com/iframe_api", () => window.YT && window.YT.Player).then(() => {
			const ready = () => {
				new window.YT.Player(iframe, {
					events: {
						onReady: (event) => event.target.playVideo(),
						onStateChange: (event) => {
							if (event.data === window.YT.PlayerState.ENDED) {
								fadeOutIntro(intro);
							}
						},
					},
				});
			};
			if (window.YT && window.YT.Player) {
				ready();
			} else {
				const previousCallback = window.onYouTubeIframeAPIReady;
				window.onYouTubeIframeAPIReady = () => {
					if (typeof previousCallback === "function") previousCallback();
					ready();
				};
			}
		});

		removePlaceholder(intro);
	}, { once: true });
}

function setupVimeoIntro(intro) {
	intro.addEventListener("click", () => {
		const iframe = document.createElement("iframe");
		iframe.setAttribute("frameborder", "0");
		iframe.setAttribute("allow", "autoplay");
		iframe.src = `https://player.vimeo.com/video/${intro.dataset.videoSrc}?autoplay=1&background=0&title=0&byline=0&portrait=0`;
		intro.prepend(iframe);

		loadScriptOnce("https://player.vimeo.com/api/player.js", () => window.Vimeo && window.Vimeo.Player).then(() => {
			const player = new window.Vimeo.Player(iframe);
			player.play();
			player.on("ended", () => fadeOutIntro(intro));
		});

		removePlaceholder(intro);
	}, { once: true });
}

export function photogalleryVideoIntro() {
	document.querySelectorAll(".site-photogallery__video-intro").forEach((intro) => {
		const type = intro.dataset.videoType;

		if (type === "file") {
			setupFileIntro(intro);
		} else if (type === "youtube") {
			setupYoutubeIntro(intro);
		} else if (type === "vimeo") {
			setupVimeoIntro(intro);
		}
	});
}
